/**
 * Centralized exports for AutomationV2 constants
 */

export { FLOW_COLORS } from './colors';
export { DEFAULT_ACTIONS, DEFAULT_DELAY_MS } from './defaults';
